export const USERS_API_URL: string | undefined = process.env['NX_USERS_API_URL'];
export const PLATFORM_URL: string | undefined = process.env['NX_PLATFORM_URL'];
export const BASE_URL: string | undefined = process.env['NX_BASE_URL'];
export const STORK_PLATFORM_URL: string | undefined = process.env['NX_STORK_PLATFORM_URL'];
export const STORK_AUTH_API_URL: string | undefined = process.env['NX_STORK_AUTH_API_URL'];
export const AUTH_API_URL: string | undefined = process.env['NX_AUTH_API_URL'];
